<template>
  <!-- 根布局容器：必须包裹所有内容 -->
  <a-layout style="min-height: 100vh;">
    <!-- 侧边栏：无需 fixed，由布局容器自动控制 -->
    <a-layout-sider width="200" class="sider">
      <a-menu v-model:selectedKeys="selectedKeys" v-model:openKeys="openKeys" mode="inline" class="menu">
        <!-- 产品开发者 -->
        <a-sub-menu key="sub1">
          <template #title>
            <component :is="BarChartOutlined" />
            <span>概览</span>
          </template>
          <a-menu-item key="1">产品开发者数量</a-menu-item>
          <a-menu-item key="4">XTS 产品全景图</a-menu-item>
          <a-menu-item key="5">潜在捐赠伙伴</a-menu-item>
        </a-sub-menu>
        <!-- 统计清单 -->
        <a-menu-item key="2">
          <component :is="TableOutlined" />
          <span>统计清单</span>
        </a-menu-item>
        <!-- 商用案例区域分析 -->
        <a-menu-item key="3">
          <component :is="TableOutlined" />
          <span>商用案例区域分析</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>

    <!-- 主内容容器：自动占据侧边栏右侧剩余空间 -->
    <a-layout class="main-layout">
      <!-- 页面内容：只在右侧区域渲染 -->
      <main class="content-scroll">
        <developer-overview v-if="selectedKeys[0] === '1'" />
        <DeveloperStatisticalList v-if="selectedKeys[0] === '2'" />
        <CommercialCase v-if="selectedKeys[0] === '3'" />
        <XtsProductOverview v-if="selectedKeys[0] === '4'" />
        <PotentialDonors v-if="selectedKeys[0] === '5'" />
      </main>
    </a-layout>
  </a-layout>
</template>

<script setup>
import { ref } from 'vue';
import { BarChartOutlined, TableOutlined } from '@ant-design/icons-vue';
import DeveloperOverview from './DeveloperOverview.vue';
import DeveloperStatisticalList from './DeveloperStatisticalList.vue';
import CommercialCase from './CommercialCase.vue';
import XtsProductOverview from './XtsProductOverview.vue';
import PotentialDonors from './PotentialDonors.vue';

// 菜单选中项（默认选中概览下的产品开发者数量）
const selectedKeys = ref(['1']);
// 打开的子菜单
const openKeys = ref(['sub1']);
</script>

<style scoped>
/* 侧边栏样式：仅保留基础样式，删除 fixed 定位 */
.sider {
  box-shadow: 2px 0 8px #f0f1f2;
}

/* 菜单样式：宽度由 sider 控制，无需重复设置 */
.menu {
  height: 100%;
  border-right: 0;
  text-align: left;
}

/* 主内容容器：确保占满剩余空间 */
.main-layout {
  background: #f9fafb;
}

/* 内容滚动区域：保留原有样式 */
.content-scroll {
  padding: 0 24px 24px;
  overflow-y: auto;
  flex: 1;
}
</style>